import ConfigurationNew from './ConfigurationNew';

export default ConfigurationNew;
